export default __webpack_public_path__ + "static/media/roundButton.a0b9a1ad.svg";